/**
 * Birch AI floating action bar — Slice 6.
 *
 * Docks at the bottom of the screen as soon as the user has ≥1 items in
 * `BirchAI.selection`. Action visibility scales with selection size:
 *   - "Ask Birch" — visible whenever the bar is visible (≥1 selected)
 *   - "Compare"   — only when ≥2 selected (comparing 1 product is nonsense)
 *   - "Clear"     — always visible when the bar is up
 *
 * Reads selection from `window.BirchAI.selection.list()` and listens for
 * `birch:selection:changed` to re-render. No-op until BirchAI.selection
 * exists (load order: selection.js, then this file, then companion.js).
 */

// @ts-check

(function () {
  function ensureBar() {
    let bar = document.getElementById('birch-ai-actionbar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'birch-ai-actionbar';
    bar.className = 'birch-ai-actionbar';
    bar.setAttribute('role', 'toolbar');
    bar.setAttribute('aria-label', 'Selected products actions');
    document.body.appendChild(bar);
    return bar;
  }

  function render() {
    const w = /** @type {any} */ (window);
    if (!w.BirchAI?.selection) return;
    const entries = w.BirchAI.selection.list();
    const bar = ensureBar();

    if (entries.length < 1) {
      bar.style.display = 'none';
      return;
    }

    // Compare requires ≥2 items; "Ask Birch" works with just 1. Primary
    // action also flips: with one item selected, "Ask Birch" becomes the
    // primary CTA so the user has an obvious next step.
    const canCompare = entries.length >= 2;
    const compareBtn = canCompare
      ? `<button type="button" class="birch-ai-actionbar__btn birch-ai-actionbar__btn--primary" data-action="compare">Compare</button>`
      : '';
    const askClass = canCompare
      ? 'birch-ai-actionbar__btn'
      : 'birch-ai-actionbar__btn birch-ai-actionbar__btn--primary';

    bar.style.display = '';
    bar.innerHTML = `
      <span class="birch-ai-actionbar__count">${entries.length} selected</span>
      <div class="birch-ai-actionbar__chips">
        ${entries.map((e) => `<span class="birch-ai-actionbar__chip" title="${esc(e.title || e.handle)}">${esc(short(e.title || e.handle))}</span>`).join('')}
      </div>
      <div class="birch-ai-actionbar__actions">
        ${compareBtn}
        <button type="button" class="${askClass}" data-action="ask">Ask Birch</button>
        <button type="button" class="birch-ai-actionbar__btn birch-ai-actionbar__btn--ghost" data-action="clear" aria-label="Clear selection">Clear</button>
      </div>
    `;

    // Compare / Ask Birch "send" the current selection into the chat. openWithContext
    // snapshots the selection onto the dispatched event synchronously, so clearing
    // right after is safe — the chat still receives the products, while the bar and
    // the in-card "+" checkmarks reset through the normal birch:selection:changed flow.
    bar.querySelector('[data-action="compare"]')?.addEventListener('click', () => {
      w.BirchAI.openWithContext({ query: 'Compare these', source: 'actionbar' });
      w.BirchAI.selection.clear();
    });
    bar.querySelector('[data-action="ask"]')?.addEventListener('click', () => {
      w.BirchAI.openWithContext({ source: 'actionbar' });
      w.BirchAI.selection.clear();
    });
    bar.querySelector('[data-action="clear"]')?.addEventListener('click', () => {
      w.BirchAI.selection.clear();
    });
  }

  /** @param {string} s */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }
  /** @param {string} s */
  function short(s) {
    return s.length > 20 ? s.slice(0, 18) + '…' : s;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
  window.addEventListener('birch:selection:changed', render);
})();
